module.exports = __webpack_public_path__ + "static/one-d76f89455c5440326508cd5904db3964.png";